import { Component } from 'react';
import * as React from 'react';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { LinkSectionButton } from '../../uiComponents/input/Buttons';
import { getSite } from '../../infrastructure/site/SiteProvider';
import { HelpCardSection } from '../../uiComponents/layout/HelpCardSection';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { SelectFormControl } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import * as moment from 'moment';
import HelperMethods from '../../infrastructure/HelperMethods';
import { Spinner } from '../../uiComponents/Spinner';
import { KonkurrenceTilEkstern } from '../../models/KonkurrenceTilEkstern';
import { KonkurrenceOverblikEkstern } from '../../models/KonkurrenceOverblikEkstern';
import KonkurrenceOverblikEksternContainer from './konkurrenceOverblik/KonkurrenceOverblikEksternContainer';
import { EmptyState } from '../../uiComponents/EmptyState';

export interface SkrivebordEksternProps {
}

export interface SkrivebordEksternState {
    konkurrencer?: KonkurrenceTilEkstern[];
    kommendeKonkurrencer?: KonkurrenceTilEkstern[];
    selectedKonkurrenceId?: string;
    konkurrenceOverblik?: KonkurrenceOverblikEkstern;
    isLoading: boolean;
}

class SkrivebordEkstern extends Component<SkrivebordEksternProps, SkrivebordEksternState> {
    constructor(props: SkrivebordEksternProps) {
        super(props);

        this.state = {
            konkurrencer: undefined,
            kommendeKonkurrencer: undefined,
            selectedKonkurrenceId: undefined,
            konkurrenceOverblik: undefined,
            isLoading: true
        };
    }

    componentDidMount() {
        let apiCaller = createApiCaller();

        apiCaller.GetAlleKonkurrencerTilEkstern().then((konkurrencer: KonkurrenceTilEkstern[]) => {
            let selectedKonkurrenceId: string | undefined = undefined;
            let konkurrenceOverblik = undefined;         
            
            if (konkurrencer.length > 0) {
                let snarestKommendeKonkurrence = this.getSnarestkommendeKonkurrence(konkurrencer);
                let senesteKonkurrence = this.getSenesteKonkurrence(konkurrencer);
                
                selectedKonkurrenceId = snarestKommendeKonkurrence !== undefined ? snarestKommendeKonkurrence.id : senesteKonkurrence !== undefined ? senesteKonkurrence.id : undefined;
            }

            if (selectedKonkurrenceId !== undefined && selectedKonkurrenceId.length > 0) {
                apiCaller.getKonkurrenceEksternOverblik(selectedKonkurrenceId).then(response => {
                    konkurrenceOverblik = response;

                    this.setState({
                        konkurrencer: konkurrencer,
                        selectedKonkurrenceId: selectedKonkurrenceId,
                        konkurrenceOverblik: konkurrenceOverblik,
                        isLoading: false
                    });
                });
            } else {
                this.setState({
                    konkurrencer: konkurrencer,
                    selectedKonkurrenceId: selectedKonkurrenceId,
                    konkurrenceOverblik: konkurrenceOverblik,
                    isLoading: false
                });
            }
        });
        
        apiCaller.getKommendeKonkurrencerTilEkstern().then((konkurrencer: KonkurrenceTilEkstern[]) => {
            this.setState({
                kommendeKonkurrencer: konkurrencer
            });
        });
    }

    getSnarestkommendeKonkurrence(konkurrencer: KonkurrenceTilEkstern[]) {
        let konkurrencerSorted = konkurrencer.sort((a: KonkurrenceTilEkstern, b: KonkurrenceTilEkstern) => {
            if (a.dato > b.dato) {
                return 1;
            }
            if (a.dato < b.dato) {
                return -1;
            }
            return 0;
        });

        return konkurrencerSorted.find(konkurrence => new Date(new Date(konkurrence.dato).toDateString()) >= new Date(new Date().toDateString()));
    }

    getSenesteKonkurrence(konkurrencer: KonkurrenceTilEkstern[]) {
        let konkurrencerSorted = konkurrencer.sort((a: KonkurrenceTilEkstern, b: KonkurrenceTilEkstern) => {
            if (a.dato < b.dato) {
                return 1;
            }
            if (a.dato > b.dato) {
                return -1;
            }
            return 0;
        });

        return konkurrencerSorted.find(konkurrence => new Date(new Date(konkurrence.dato).toDateString()) <= new Date(new Date().toDateString()));
    }

    componentDidUpdate(prevProps: any, prevState: SkrivebordEksternState) {
        if (this.state.selectedKonkurrenceId !== prevState.selectedKonkurrenceId) {
            let apiCaller = createApiCaller();
            if (this.state.selectedKonkurrenceId !== undefined && this.state.selectedKonkurrenceId.length > 0) {
                apiCaller.getKonkurrenceEksternOverblik(this.state.selectedKonkurrenceId).then(response => {
                    this.setState({
                        konkurrenceOverblik: response
                    });
                });
            }
        }
    }

    onKonkurrenceTilEksternSelectChange = (e: any) => {
        let selectedKonkurrence = undefined;
        let konkurrenceId = e.target.value;

        if (konkurrenceId !== undefined && this.state.konkurrencer !== undefined && this.state.konkurrencer.length > 0) {
            selectedKonkurrence = this.state.konkurrencer.find(function (element: any) {
                return element.id === konkurrenceId;
            });
        }

        let selectedKonkurrenceId = selectedKonkurrence !== undefined ? selectedKonkurrence.id : undefined;

        this.setState({
            selectedKonkurrenceId: selectedKonkurrenceId
        });
    }

    getKonkurrenceTilEksternSelect = () => {
        if (this.state.konkurrencer !== undefined && this.state.konkurrencer.length > 0) {
            let konkurrencerFiltered = HelperMethods.distinctArrayByProp(this.state.konkurrencer, 'id');
            const konkurrenceList = konkurrencerFiltered
                .map((k, i) => {
                    const formattedDate = moment(k.dato.toString()).format('DD.MM.YY');
                    return <option key={k.id} value={k.id}>{formattedDate} - {k.konkurrenceTitel}</option>;
                });

            return (
                <SelectFormControl
                    label='Vælg konkurrence'
                    value={this.state.selectedKonkurrenceId}
                    onChange={this.onKonkurrenceTilEksternSelectChange}
                    className='konkurrenceTilEkstern-select'
                >
                    {konkurrenceList}
                </SelectFormControl>
            );
        }

        return undefined;
    }

    getKonkurrenceoverblikState() {
        if (this.state.konkurrencer !== undefined) {
            if (this.state.konkurrencer.length > 0) {
                return (
                    <SectionGroup header={'Konkurrenceoverblik'}>
                        {this.getKonkurrenceTilEksternSelect()}
                        <KonkurrenceOverblikEksternContainer
                            konkurrenceId={this.state.selectedKonkurrenceId}
                            isLaererSkrivebord={true}
                            konkurrenceOverblik={this.state.konkurrenceOverblik}
                        />
                    </SectionGroup>
                );
            } else {
                return (
                    <SectionGroup header={'Konkurrenceoverblik'}>
                        <EmptyState header='Du er endnu ikke tilmeldt nogen konkurrencer' />
                    </SectionGroup>
                );

            }
        }

        return undefined;
    }

    render() {
        const helpCardTitle = 'Hjælp til ' + getSite().navn;
        const opgavepakker = this.state.konkurrenceOverblik ? 
            this.state.konkurrenceOverblik.opgavepakker.map(o => <LinkSectionButton key={o.id} url={'/opgavepakke/vejledning/' + o.id} text={o.titel} />)
            : null;
        
        const helpContent = (
            <div>
                {opgavepakker}
                <LinkSectionButton url='/support' text='Support' />
            </div>
        );

        const konkurrenceoverblikState = this.getKonkurrenceoverblikState();    

        if (this.state.isLoading) {
            return <Spinner />;
        }

        return (
            <PageWrapper className='eksternskrivebord'>
                <PageTitle title='Skrivebord' />
                <ContentWrapper>
                    {konkurrenceoverblikState}              
                    <HelpCardSection title={helpCardTitle} content={helpContent} />
                </ContentWrapper>
            </PageWrapper>
        );
    }
}

export default SkrivebordEkstern;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/skrivebord/SkrivebordEkstern.tsx